"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadDocument = exports.deleteDocument = exports.getSignedUrl = exports.getDocuments = void 0;
const getDocuments = async (supabase, bucket, folder) => {
    const { data, error } = await supabase.storage.from(bucket).list(folder, {
        limit: 100,
        offset: 0,
        sortBy: { column: "name", order: "asc" },
    });
    if (!error)
        return data;
    return [];
};
exports.getDocuments = getDocuments;
const getSignedUrl = async (supabase, bucket, folder, path) => {
    const { data, error } = await supabase.storage
        .from(bucket)
        .createSignedUrl(`${folder}/${path}`, 60 * 60 * 24);
    if (!error)
        return data.signedUrl;
    return null;
};
exports.getSignedUrl = getSignedUrl;
const deleteDocument = async (supabase, bucket, folder, path) => {
    const { error } = await supabase.storage
        .from(bucket)
        .remove([`${folder}/${path}`]);
    if (!error)
        return true;
    return false;
};
exports.deleteDocument = deleteDocument;
const uploadDocument = async (supabase, bucket, folder, filename, file) => {
    const { data, error } = await supabase.storage
        .from(bucket)
        .upload(folder + "/" + filename, file, {
        cacheControl: "3600",
        upsert: true,
    });
    if (!error)
        return {
            success: true,
            response: data,
        };
    return {
        success: false,
        response: error.message,
    };
};
exports.uploadDocument = uploadDocument;
